/* Ascrono teams page (w25 Q2 A): the form builds the team's offer, plays "putting your offer together",
   fills the cart through window.ascCart (fallback /cart/add.js + asc:cart:open) and opens it.
   Owner: teams workstream. No real submits unless the section's lead capture setting is on. */
(function () {
  'use strict';

  var TRAY_SIZES = { S: 'Mini', M: 'Regular', L: 'Large', XL: 'Extra-Large' };
  var TRAY_LENGTH = { S: '14.1 in', M: '27.3 in', L: '40.6 in', XL: '53.9 in' };
  var TRAY_ORDER = ['S', 'M', 'L', 'XL'];
  var COLOURS = { B: 'Black', W: 'White' };
  var MAX_QTY = 999;
  var STEP_MS = 650;

  function init(root) {
    var cfgEl = root.querySelector('[data-asc-teams-config]');
    var form = root.querySelector('[data-asc-teams-form]');
    if (!cfgEl || !form) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var params = new URLSearchParams(location.search);
    var demo = params.get('teams_demo') === '1';
    var captureVisible = cfg.capture.on || demo;
    var reduceMq = window.matchMedia('(prefers-reduced-motion: reduce)');

    var docks = {};
    cfg.docks.forEach(function (d) { docks[d.key] = d; });
    var traysBySku = {};
    cfg.trays.forEach(function (t) { traysBySku[t.size + '-' + t.colour] = t; });
    var traySizes = TRAY_ORDER.filter(function (s) { return traysBySku[s + '-B'] || traysBySku[s + '-W']; });

    var el = {
      count: form.querySelector('[data-count]'),
      errsum: form.querySelector('[data-errsum]'),
      submit: form.querySelector('[data-submit]'),
      trayToggle: form.querySelector('[data-tray-toggle]'),
      trayRows: form.querySelector('[data-tray-rows]'),
      trayList: form.querySelector('[data-tray-list]'),
      trayAdd: form.querySelector('[data-tray-add]'),
      trayMatch: form.querySelector('[data-tray-match]'),
      done: form.querySelector('[data-done]'),
      doneTitle: form.querySelector('[data-done-title]'),
      doneText: form.querySelector('[data-done-text]'),
      copy: form.querySelector('[data-copy-link]'),
      copyStatus: form.querySelector('[data-copy-status]'),
      openCart: form.querySelector('[data-open-cart]'),
      ov: root.querySelector('[data-asc-teams-ov]'),
      ovSteps: root.querySelector('[data-ov-steps]'),
      ovBar: root.querySelector('[data-ov-bar]'),
      ovErr: root.querySelector('[data-ov-err]'),
      ovErrText: root.querySelector('[data-ov-errtext]'),
      ovBack: root.querySelector('[data-ov-back]'),
      ovPrice: root.querySelector('[data-ov-price]'),
      ovTitle: root.querySelector('.asc-teams__ovh')
    };

    if (captureVisible) {
      root.querySelectorAll('[data-capture-only]').forEach(function (n) { n.hidden = false; });
      form.elements.email.required = true;
    }

    /* ---------- money ---------- */
    var money = (function () {
      var m = /1(\D?)234(\D?)56/.exec(cfg.money || '');
      if (!m) {
        var nf;
        try { nf = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cfg.currency || 'USD' }); } catch (e) { nf = null; }
        return function (c) { return nf ? nf.format(c / 100) : (c / 100).toFixed(2); };
      }
      var pre = cfg.money.slice(0, m.index);
      var post = cfg.money.slice(m.index + m[0].length);
      var th = m[1];
      var dec = m[2] || '.';
      return function (cents) {
        var neg = cents < 0;
        cents = Math.abs(Math.round(cents));
        var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, th);
        var frac = String(cents % 100).padStart(2, '0');
        return (neg ? '−' : '') + pre + whole + dec + frac + post;
      };
    })();

    /* ---------- dock steppers ---------- */
    function clampQty(v) {
      v = parseInt(String(v).trim(), 10);
      if (!isFinite(v) || v < 0) v = 0;
      return Math.min(v, MAX_QTY);
    }
    // Quantity boxes are text inputs with a numeric keypad (selection works in iOS Safari, unlike type=number).
    // Focus (tap, click or Tab) selects the whole value so typing replaces it: tap "0", type 12 → 12, never 120.
    // A tap's mouseup would undo the selection in Safari, so the first one after focus is swallowed.
    function numberField(input, step) {
      var justFocused = false;
      input.addEventListener('focus', function () {
        justFocused = true;
        setTimeout(function () { try { input.setSelectionRange(0, input.value.length); } catch (e) { try { input.select(); } catch (e2) {} } }, 0);
      });
      input.addEventListener('mouseup', function (e) { if (justFocused) { e.preventDefault(); justFocused = false; } });
      input.addEventListener('touchend', function () { setTimeout(function () { if (document.activeElement === input && justFocused) { try { input.setSelectionRange(0, input.value.length); } catch (e) {} } justFocused = false; }, 0); });
      input.addEventListener('blur', function () { justFocused = false; });
      input.addEventListener('beforeinput', function (e) {
        // Digits only; anything else (letters, minus, paste of text) is ignored.
        if (e.inputType === 'insertText' && e.data && /\D/.test(e.data)) e.preventDefault(); // pastes are cleaned by tidyDigits
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowUp') { e.preventDefault(); step(1); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); step(-1); }
      });
    }
    // "007" → "7", "0" stays "0"; strips anything that is not a digit.
    function tidyDigits(input) {
      var v = input.value.replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, 3);
      if (v !== input.value) input.value = v;
      return v;
    }
    var macEls = Array.prototype.slice.call(form.querySelectorAll('[data-mac]'));
    macEls.forEach(function (card) {
      var input = card.querySelector('.asc-teams__qty');
      if (!input) return;
      card.querySelector('[data-dec]').addEventListener('click', function () { setDock(card, clampQty(input.value) - 1); });
      card.querySelector('[data-inc]').addEventListener('click', function () { setDock(card, clampQty(input.value) + 1); });
      numberField(input, function (d) { setDock(card, clampQty(input.value) + d); });
      input.addEventListener('input', function () { var v = tidyDigits(input); if (v !== '') setDock(card, clampQty(v), true); else update(); });
      input.addEventListener('change', function () { setDock(card, clampQty(input.value)); });
      input.addEventListener('blur', function () { if (input.value === '') setDock(card, 0); });
    });
    function setDock(card, v, typing) {
      var input = card.querySelector('.asc-teams__qty');
      v = Math.max(0, Math.min(MAX_QTY, v));
      if (!typing || String(v) !== input.value) input.value = v;
      update();
    }
    function dockQtys() {
      var out = {};
      macEls.forEach(function (card) {
        var input = card.querySelector('.asc-teams__qty');
        out[card.getAttribute('data-mac')] = input ? clampQty(input.value) : 0;
      });
      return out;
    }

    /* ---------- tray rows ---------- */
    var rowSeq = 0;
    function trayRowHtml(id) {
      var opts = traySizes.map(function (s) {
        return '<option value="' + s + '">' + TRAY_SIZES[s] + ' · ' + TRAY_LENGTH[s] + '</option>';
      }).join('');
      var cols = ['B', 'W'].map(function (c) {
        return '<label class="asc-teams__colour"><input type="radio" name="tray_colour_' + id + '" value="' + c + '"><i class="' + c.toLowerCase() + '" aria-hidden="true"></i>' + COLOURS[c] + '</label>';
      }).join('');
      return '<select class="asc-teams__sel" data-t-size aria-label="Tray size">' + opts + '</select>' +
        '<fieldset class="asc-teams__colours" data-t-colours><legend class="asc-sr">Tray color</legend>' + cols + '</fieldset>' +
        '<span class="asc-teams__step" role="group" aria-label="Number of trays">' +
          '<button type="button" class="asc-teams__sb" data-t-dec aria-label="One fewer tray"><span aria-hidden="true">−</span></button>' +
          '<input class="asc-teams__qty" type="text" inputmode="numeric" pattern="[0-9]*" maxlength="3" autocomplete="off" value="1" data-t-qty aria-label="Number of trays">' +
          '<button type="button" class="asc-teams__sb" data-t-inc aria-label="One more tray"><span aria-hidden="true">+</span></button>' +
        '</span>' +
        '<span class="asc-teams__tprice" data-t-price aria-live="polite"></span>' +
        '<button type="button" class="asc-teams__trm" data-t-remove aria-label="Remove this tray row">' +
          '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 3.5l9 9m0-9-9 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
        '</button>';
    }
    function addTrayRow(size, colour, qty, focus) {
      if (!el.trayList || !traySizes.length) return null;
      var id = ++rowSeq;
      var row = document.createElement('div');
      row.className = 'asc-teams__trow';
      row.setAttribute('data-trow', id);
      row.innerHTML = trayRowHtml(id);
      el.trayList.appendChild(row);
      var sel = row.querySelector('[data-t-size]');
      sel.value = traySizes.indexOf(size) > -1 ? size : (traySizes.indexOf('L') > -1 ? 'L' : traySizes[0]);
      var radios = row.querySelectorAll('input[type=radio]');
      var col = colour === 'W' ? 'W' : 'B';
      radios.forEach(function (r) { r.checked = r.value === col; });
      var q = row.querySelector('[data-t-qty]');
      q.value = Math.max(1, Math.min(MAX_QTY, qty || 1));
      sel.addEventListener('change', function () { fixColour(row); update(); });
      radios.forEach(function (r) { r.addEventListener('change', update); });
      row.querySelector('[data-t-dec]').addEventListener('click', function () { q.value = Math.max(1, clampQty(q.value) - 1); update(); });
      row.querySelector('[data-t-inc]').addEventListener('click', function () { q.value = Math.min(MAX_QTY, clampQty(q.value) + 1); update(); });
      numberField(q, function (d) { q.value = Math.max(1, Math.min(MAX_QTY, clampQty(q.value) + d)); update(); });
      q.addEventListener('input', function () { tidyDigits(q); update(); });
      q.addEventListener('change', function () { q.value = Math.max(1, clampQty(q.value)); update(); });
      q.addEventListener('blur', function () { if (q.value === '' || clampQty(q.value) < 1) { q.value = 1; update(); } });
      row.querySelector('[data-t-remove]').addEventListener('click', function () {
        var next = row.nextElementSibling || row.previousElementSibling;
        row.remove();
        if (!el.trayList.children.length) {
          el.trayToggle.checked = false;
          syncTrayToggle();
          el.trayToggle.focus();
        } else if (next) {
          next.querySelector('[data-t-size]').focus();
        }
        update();
      });
      fixColour(row);
      if (focus) sel.focus();
      return row;
    }
    function fixColour(row) {
      var size = row.querySelector('[data-t-size]').value;
      var radios = row.querySelectorAll('input[type=radio]');
      radios.forEach(function (r) {
        var t = traysBySku[size + '-' + r.value];
        r.disabled = !t || !t.available;
        r.parentNode.title = r.disabled ? 'Sold out in this size' : '';
      });
      var checked = row.querySelector('input[type=radio]:checked');
      if (!checked || checked.disabled) {
        var firstOk = Array.prototype.find.call(radios, function (r) { return !r.disabled; });
        if (firstOk) firstOk.checked = true;
      }
    }
    function trayRows() {
      if (!el.trayToggle || !el.trayToggle.checked) return [];
      return Array.prototype.map.call(el.trayList.querySelectorAll('[data-trow]'), function (row) {
        var size = row.querySelector('[data-t-size]').value;
        var c = row.querySelector('input[type=radio]:checked');
        var colour = c ? c.value : 'B';
        return { row: row, size: size, colour: colour, qty: Math.max(1, clampQty(row.querySelector('[data-t-qty]').value)), variant: traysBySku[size + '-' + colour] || null };
      });
    }
    function syncTrayToggle() {
      if (!el.trayToggle) return;
      var on = el.trayToggle.checked;
      el.trayToggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      el.trayRows.hidden = !on;
      if (on && !el.trayList.children.length) addTrayRow('L', 'B', 1, false);
    }
    if (el.trayToggle) {
      el.trayToggle.addEventListener('change', function () { syncTrayToggle(); update(); });
      el.trayAdd.addEventListener('click', function () {
        // Next size/colour not yet used, so a second row is a real choice rather than a duplicate.
        var used = trayRows().map(function (r) { return r.size + '-' + r.colour; });
        var pick = null;
        ['L', 'M', 'XL', 'S'].some(function (s) {
          return ['B', 'W'].some(function (c) {
            var t = traysBySku[s + '-' + c];
            if (t && t.available && used.indexOf(s + '-' + c) < 0) { pick = [s, c]; return true; }
            return false;
          });
        });
        pick = pick || ['L', 'B'];
        addTrayRow(pick[0], pick[1], 1, true);
        update();
      });
      el.trayMatch.addEventListener('click', function () {
        var n = total(dockQtys());
        var rows = trayRows();
        if (!n || !rows.length) return;
        rows.forEach(function (r, i) { if (i > 0) r.row.remove(); });
        rows[0].row.querySelector('[data-t-qty]').value = Math.min(MAX_QTY, n);
        update();
      });
    }

    /* ---------- summary ---------- */
    function total(q) { return Object.keys(q).reduce(function (s, k) { return s + q[k]; }, 0); }
    function plural(n, one, many) { return n + ' ' + (n === 1 ? one : many); }
    function dockSubtotal(q) { return Object.keys(q).reduce(function (s, k) { return s + (docks[k] ? docks[k].price * q[k] : 0); }, 0); }
    // Team price tiers (decided FR1): [{min: 5, pct: 3}, {min: 10, pct: 6}] from the section settings; docks only.
    var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
    function tierFor(n) { var t = null; tiers.forEach(function (x) { if (n >= x.min) t = x; }); return t; }
    function nextTier(n) { return tiers.filter(function (x) { return n < x.min; })[0] || null; }
    // The team price is ONLY a form-applied discount code (decided 2026-10-19). The codes are not in this page: they are
    // fetched from the layout-less view "asc-teams-codes" after a submission with a valid work email (see fillCart).
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    function parseCodes(raw) {
      var map = {};
      String(raw || '').split(',').forEach(function (part) {
        var m = /^\s*(\d+(?:\.\d+)?)\s*:\s*([A-Za-z0-9_-]+)\s*$/.exec(part);
        if (m) map[String(parseFloat(m[1]))] = m[2];
      });
      return map;
    }
    function fetchCodes() {
      return fetch(location.pathname + '?view=asc-teams-codes', { credentials: 'same-origin', headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = /data-asc-teams-codes>([\s\S]*?)<\/script>/.exec(html);
          try { return parseCodes(m ? JSON.parse(m[1]) : ''); } catch (e) { return {}; }
        }, function () { return {}; });
    }
    function teamSaving(q) {
      var t = cfg.priceOn ? tierFor(total(q)) : null;
      if (!t) return 0;
      // Shopify takes the percentage of each unit and rounds DOWN to the cent (6% of $209.99 = $12.59), times quantity
      // (measured on the real cart 2026-10-19: 4 × $209.99 at 6% → −$50.36). Mirror that exactly.
      return Object.keys(q).reduce(function (s, k) { return s + (docks[k] ? Math.floor(docks[k].price * t.pct / 100 + 1e-9) * q[k] : 0); }, 0);
    }
    // List total → team price → team total. `real` = amounts Shopify applied (cart), else the expected team price.
    function priceTable(list, save, real, parts) {
      if (!save) return '';
      var head = parts && parts.trays
        ? '<div><dt>' + plural(parts.n, 'dock', 'docks') + '</dt><dd class="asc-price">' + money(parts.docks) + '</dd></div>' +
          '<div><dt>' + plural(parts.nt, 'CableCare Tray', 'CableCare Trays') + '</dt><dd class="asc-price">' + money(parts.trays) + '</dd></div>'
        : '<div><dt>List price</dt><dd class="asc-price">' + money(list) + '</dd></div>';
      return '<dl class="asc-teams__pt">' + head +
        '<div class="is-save"><dt>Team price −' + (parts && parts.pct) + '%</dt><dd class="asc-price">−' + money(save) + '</dd></div>' +
        '<div class="is-total"><dt>Your team total</dt><dd class="asc-price">' + money(list - save) + '</dd></div>' +
        '</dl><p class="asc-teams__ptnote">' + (real ? 'Team price applied in your cart.' : 'Applied in your cart when you send this form.') + '</p>';
    }
    function mergedTrays(rows) {
      var m = {};
      rows.forEach(function (r) {
        if (!r.variant) return;
        var k = r.variant.id;
        if (!m[k]) m[k] = { variant: r.variant, qty: 0, size: r.size, colour: r.colour };
        m[k].qty += r.qty;
      });
      return Object.keys(m).map(function (k) { return m[k]; });
    }

    function update() {
      var q = dockQtys();
      var n = total(q);
      macEls.forEach(function (card) {
        var k = card.getAttribute('data-mac');
        card.classList.toggle('is-on', q[k] > 0);
        var dec = card.querySelector('[data-dec]');
        if (dec) dec.setAttribute('aria-disabled', q[k] > 0 ? 'false' : 'true');
      });
      var rows = trayRows();
      var seen = {};
      rows.forEach(function (r) {
        var priceEl = r.row.querySelector('[data-t-price]');
        var dec = r.row.querySelector('[data-t-dec]');
        dec.setAttribute('aria-disabled', r.qty > 1 ? 'false' : 'true');
        var key = r.size + '-' + r.colour;
        var note = r.row.querySelector('.asc-teams__trownote');
        if (seen[key]) {
          if (!note) { note = document.createElement('p'); note.className = 'asc-teams__trownote'; r.row.appendChild(note); }
          note.textContent = 'Same size and color as a row above; they go into the cart together.';
        } else if (note) { note.remove(); }
        seen[key] = true;
        if (!r.variant) { priceEl.textContent = 'Not available'; return; }
        priceEl.innerHTML = money(r.variant.price * r.qty) + (r.qty > 1 ? '<small>' + money(r.variant.price) + ' each</small>' : '');
      });
      if (el.trayAdd) {
        var availableCombos = cfg.trays.filter(function (t) { return t.available; }).length;
        el.trayAdd.hidden = rows.length >= availableCombos;
      }
      if (el.trayMatch) {
        el.trayMatch.hidden = !(rows.length && n > 0 && !(rows.length === 1 && rows[0].qty === n));
        el.trayMatch.textContent = 'One tray per dock (' + n + ')';
      }

      var models = Object.keys(q).filter(function (k) { return q[k] > 0; }).length;
      var sub = dockSubtotal(q);
      var msg;
      var price = '<span class="asc-price">' + money(sub) + '</span>';
      var teamOn = cfg.priceOn && tiers.length > 0;
      var tier = teamOn ? tierFor(n) : null;
      var next = teamOn ? nextTier(n) : null;
      if (n === 0) {
        msg = teamOn ? 'Team price: <b>' + tiers[0].pct + '% off every dock</b> from ' + tiers[0].min + ' docks' + (tiers[1] ? ', <b>' + tiers[1].pct + '%</b> from ' + tiers[1].min : '') + '.' : 'Team orders start at <b>' + cfg.min + ' docks</b>.';
      } else if (n < cfg.min) {
        var more = cfg.min - n;
        msg = plural(n, 'dock', 'docks') + ' so far. Add <b>' + more + ' more</b> ' +
          (teamOn ? 'for the team price: ' + tiers[0].pct + '% off every dock. ' : 'to reach the team minimum of ' + cfg.min + '. ') +
          'Fewer than ' + cfg.min + '? <a class="asc-teams__a" href="' + cfg.dockPage + '">Order on the dock page</a>.';
      } else {
        var trays = mergedTrays(rows);
        var nt = trays.reduce(function (x, t) { return x + t.qty; }, 0);
        var traySub = trays.reduce(function (x, t) { return x + t.variant.price * t.qty; }, 0);
        msg = '<b>' + plural(n, 'dock', 'docks') + '</b> for ' + plural(models, 'MacBook model', 'MacBook models');
        if (nt) {
          msg += ' and <b>' + plural(nt, 'CableCare Tray', 'CableCare Trays') + '</b>: <span class="asc-price">' + money(sub + traySub) + '</span>' +
            ' (docks <span class="asc-price">' + money(sub) + '</span>, trays <span class="asc-price">' + money(traySub) + '</span>)';
        } else {
          msg += ': ' + price;
        }
        var save = teamSaving(q);
        if (save > 0) {
          msg = '<span class="asc-teams__ptlead">' + msg.replace(/:.*$/, '') + '</span>' + priceTable(sub + traySub, save, false, { n: n, nt: nt, docks: sub, trays: traySub, pct: tier.pct }) +
            (next ? '<p class="asc-teams__nudge">Add <b>' + plural(next.min - n, 'more dock', 'more docks') + '</b> for <b>' + next.pct + '% off every dock</b>.</p>' : '');
        } else {
          msg += '.';
        }
      }
      el.count.innerHTML = msg;
      // The button stays active (tobias-eyes #36): a tap with missing input explains and focuses the gap.
      el.submit.removeAttribute('aria-disabled');
      if (!el.errsum.hidden && lastErrors) validate(true);
    }

    /* ---------- validation ---------- */
    var lastErrors = null;
    function fieldError(name, text) {
      var wrap = form.querySelector('[data-field="' + name + '"]');
      var err = form.querySelector('[data-err="' + name + '"]');
      if (!wrap || !err) return;
      wrap.classList.toggle('is-invalid', !!text);
      err.textContent = text || '';
      var input = form.elements[name];
      if (input) { if (text) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid'); }
    }
    function validate(quiet) {
      var errors = [];
      var name = form.elements.name.value.trim();
      var company = form.elements.company.value.trim();
      fieldError('name', name ? '' : 'Please add your name.');
      if (!name) errors.push({ field: form.elements.name, text: 'Your name' });
      fieldError('company', company ? '' : 'Please add your company or team name.');
      if (!company) errors.push({ field: form.elements.company, text: 'Company or team' });
      if (captureVisible) {
        var email = form.elements.email.value.trim();
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
        fieldError('email', ok ? '' : (email ? 'Please check the email address.' : 'Please add your work email.'));
        if (!ok) errors.push({ field: form.elements.email, text: 'Work email' });
      }
      var n = total(dockQtys());
      if (n < cfg.min) {
        var first = form.querySelector('.asc-teams__mac .asc-teams__qty');
        errors.push({ field: first, text: n === 0 ? 'Add the docks your team needs (at least ' + cfg.min + ')' : 'Add ' + (cfg.min - n) + ' more ' + (cfg.min - n === 1 ? 'dock' : 'docks') + ' (team orders start at ' + cfg.min + ')' });
      }
      var rows = trayRows();
      if (rows.some(function (r) { return !r.variant || !r.variant.available; })) {
        errors.push({ field: rows[0].row.querySelector('[data-t-size]'), text: 'One tray choice is sold out; pick another size or color' });
      }
      lastErrors = errors;
      if (errors.length) {
        el.errsum.innerHTML = '<b>Almost there:</b><ul>' + errors.map(function (e) { return '<li>' + e.text + '</li>'; }).join('') + '</ul>';
        el.errsum.hidden = false;
        if (!quiet && errors[0].field) errors[0].field.focus();
      } else {
        el.errsum.hidden = true;
        el.errsum.innerHTML = '';
      }
      return errors;
    }
    ['name', 'company', 'email'].forEach(function (f) {
      var i = form.elements[f];
      if (i) i.addEventListener('input', function () { if (lastErrors && lastErrors.length) validate(true); });
    });

    /* ---------- offer ---------- */
    function teamId() { return 'T' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 5).toUpperCase(); }
    function buildOffer() {
      var q = dockQtys();
      var company = form.elements.company.value.trim().slice(0, 80);
      var name = form.elements.name.value.trim().slice(0, 80);
      var id = teamId();
      var props = { _source: 'teams', _team: company, _team_id: id, _team_min: String(cfg.min) };
      var offerTier = cfg.priceOn ? tierFor(total(q)) : null;
      if (offerTier) props._team_pct = String(offerTier.pct); // the cart shows the same expected team price (request teams-cart-tiers)
      var items = [];
      var dockList = [];
      Object.keys(q).forEach(function (k) {
        if (q[k] > 0 && docks[k]) {
          items.push({ id: docks[k].id, quantity: q[k], properties: props });
          dockList.push({ key: k, type: docks[k].type, name: docks[k].name, qty: q[k], id: docks[k].id, price: docks[k].price });
        }
      });
      var trays = mergedTrays(trayRows());
      trays.forEach(function (t) { items.push({ id: t.variant.id, quantity: t.qty, properties: { _source: 'teams', _team: company, _team_id: id } }); });
      return {
        id: id, name: name, company: company,
        email: captureVisible ? form.elements.email.value.trim() : '',
        news: !!(form.elements.news && form.elements.news.checked),
        docks: dockList, trays: trays, items: items, total: total(q), qtys: q,
        pct: offerTier ? offerTier.pct : 0,
        dockSubtotal: dockSubtotal(q),
        traySubtotal: trays.reduce(function (s, t) { return s + t.variant.price * t.qty; }, 0),
        link: shareLink(q, trays, company)
      };
    }
    function shareLink(q, trays, company) {
      var u = new URL(location.origin + location.pathname);
      var view = params.get('view');
      if (view) u.searchParams.set('view', view);
      var d = Object.keys(q).filter(function (k) { return q[k] > 0; }).map(function (k) { return k + q[k]; }).join(',');
      if (d) u.searchParams.set('docks', d);
      var t = trays.map(function (x) { return x.size + '-' + x.colour + '-' + x.qty; }).join(',');
      if (t) u.searchParams.set('trays', t);
      if (company) u.searchParams.set('team', company);
      return u.toString();
    }
    function prefill() {
      var d = params.get('docks');
      if (d) d.split(',').forEach(function (part) {
        var m = /^([a-z])(\d{1,3})$/i.exec(part.trim());
        if (!m) return;
        var card = form.querySelector('[data-mac="' + m[1].toLowerCase() + '"]');
        var input = card && card.querySelector('.asc-teams__qty');
        if (input) input.value = clampQty(m[2]);
      });
      var t = params.get('trays');
      if (t && el.trayToggle) {
        var rows = t.split(',').map(function (part) {
          var m = /^(S|M|L|XL)-(B|W)-(\d{1,3})$/i.exec(part.trim());
          return m ? [m[1].toUpperCase(), m[2].toUpperCase(), clampQty(m[3])] : null;
        }).filter(Boolean);
        if (rows.length) {
          el.trayToggle.checked = true;
          el.trayRows.hidden = false;
          el.trayToggle.setAttribute('aria-expanded', 'true');
          rows.forEach(function (r) { addTrayRow(r[0], r[1], r[2], false); });
        }
      }
      var em = params.get('email');
      if (em && form.elements.email && !form.elements.email.value && EMAIL_RE.test(em)) form.elements.email.value = em.slice(0, 120);
      var team = params.get('team');
      if (team && !form.elements.company.value) form.elements.company.value = team.slice(0, 80);
    }

    /* ---------- cart ---------- */
    var root_ = cfg.root && cfg.root !== '/' ? cfg.root.replace(/\/?$/, '/') : '/';
    // Shopify answers 429 when the storefront is busy; retry twice with a short backoff.
    function req(path, body, tries) {
      tries = tries || 0;
      return fetch(root_ + path, {
        method: body ? 'POST' : 'GET',
        headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
        body: body ? JSON.stringify(body) : undefined,
        credentials: 'same-origin'
      }).then(function (r) {
        if (r.status === 429 && tries < 2) return wait(1200 * (tries + 1)).then(function () { return req(path, body, tries + 1); });
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || (r.status === 429 ? 'The shop is busy right now' : 'We couldn’t prepare your cart.'));
          return j;
        });
      });
    }
    function cartApi(timeout) {
      if (window.ascCart && typeof window.ascCart.add === 'function') return Promise.resolve(window.ascCart);
      return new Promise(function (resolve) {
        var t = setTimeout(function () { resolve(null); }, timeout);
        document.addEventListener('asc:cart:ready', function (e) { clearTimeout(t); resolve((e.detail && e.detail.api) || window.ascCart || null); }, { once: true });
      });
    }
    function fillCart(offer) {
      return req('cart.js').then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (i) { if (i.properties && i.properties._team_id) updates[i.key] = 0; });
        // Re-sending the form replaces the earlier team offer instead of doubling it. The team itself is
        // recorded on every line (_team, _team_id), so no extra cart write is needed otherwise.
        var replaced = Object.keys(updates).length > 0;
        return replaced ? req('cart/update.js', { updates: updates }).then(function () { return true; }) : false;
      }).then(function (replaced) {
        return cartApi(1500).then(function (api) {
          var add = api ? api.add(offer.items, { open: false, source: 'teams' }) : req('cart/add.js', { items: offer.items });
          return add.then(function () { return teamCode(offer); }).then(function () { return req('cart.js'); }).then(function (cart) { return { cart: cart, replaced: replaced, api: api }; });
        });
      });
    }
    // The team code: only for a real submission (not the ?teams_demo preview) with a valid work email and a tier.
    // Shopify's /discount/<code> link stores the code for this visitor; the cart and checkout then apply it (a GET, not
    // a cart write). The code never reaches the page markup, the URL bar, emails or links.
    function teamCode(offer) {
      if (demo || !offer.pct || !EMAIL_RE.test(offer.email || '')) return null;
      return fetchCodes().then(function (map) { return applyCode(map[String(offer.pct)]); });
    }
    function codeUrl(code) { return root_ + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root_ + 'cart.js'); }
    function applyCode(code) {
      if (!code) return null;
      var url = codeUrl(code);
      window.ascTeamsCodeApplied = true; // tests: a code was applied (never the code itself)
      return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function () { return null; }, function () { return null; });
    }
    function cartDiscountFor(cart, offer) {
      // Real discount Shopify applied to this team's dock lines (0 when no team code applied).
      var ids = offer.docks.map(function (d) { return d.id; });
      return (cart.items || []).reduce(function (s, i) {
        if (!i.properties || i.properties._team_id !== offer.id || ids.indexOf(i.variant_id) < 0) return s;
        var a = (i.line_level_discount_allocations || []).reduce(function (x, d) { return x + (d.amount || 0); }, 0);
        if (!a && i.total_discount) a = i.total_discount;
        return s + a;
      }, 0);
    }
    function openCart(api) {
      if (api && typeof api.open === 'function') { api.open(); return; }
      // Contract fallback: ask whoever listens to open the drawer; with no cart API on the page, go to /cart.
      document.dispatchEvent(new CustomEvent('asc:cart:open', { bubbles: true }));
      setTimeout(function () { if (!window.ascCart) location.href = root_ + 'cart'; }, 400);
    }

    /* ---------- lead capture (Klaviyo, off by default) ---------- */
    function permalink(offer) {
      // Shopify cart permalink: rebuilds the same lines on any device and goes to checkout with the email prefilled
      // (checkout[email], Shopify docs "cart permalinks"). Never carries the team code (codes only via the form):
      // the follow-up emails link to quote_url, where sending the form applies the team price again.
      return location.origin + root_ + 'cart/' + offer.items.map(function (i) { return i.id + ':' + i.quantity; }).join(',') +
        (offer.email ? '?checkout[email]=' + encodeURIComponent(offer.email) : '');
    }
    function leadPayload(offer) {
      var list = offer.dockSubtotal + offer.traySubtotal;
      var save = teamSaving(offer.qtys);
      var c = function (cents) { return Math.round(cents) / 100; };
      return {
        email: offer.email, first_name: offer.name.split(' ')[0], name: offer.name, company: offer.company,
        news_opt_in: offer.news, team_id: offer.id,
        docks_total: offer.total,
        docks: offer.docks.map(function (d) { return { model: d.name, type: d.type, qty: d.qty, variant_id: d.id, unit_price: c(d.price) }; }),
        trays_total: offer.trays.reduce(function (s2, t) { return s2 + t.qty; }, 0),
        trays: offer.trays.map(function (t) { return { size: TRAY_SIZES[t.size], color: COLOURS[t.colour], qty: t.qty, variant_id: t.variant.id, unit_price: c(t.variant.price) }; }),
        team_pct: offer.pct, team_price: c(save), list_total: c(list), total: c(list - save),
        currency: cfg.currency, country: cfg.country,
        cart_permalink: permalink(offer), quote_url: offer.link
      };
    }
    function sendLead(offer) {
      var payload = leadPayload(offer);
      window.ascTeamsLastLead = payload;
      if (!cfg.capture.on) return Promise.resolve({ demo: true });
      var key = encodeURIComponent(cfg.capture.key);
      var headers = { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2024-10-15' };
      var post = function (path, body) { return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + key, { method: 'POST', headers: headers, body: JSON.stringify(body) }); };
      var profileAttrs = { email: payload.email, first_name: payload.first_name, organization: payload.company, properties: { team_last_quote_url: payload.quote_url, team_last_cart_permalink: payload.cart_permalink } };
      // 1. profile (create/update), 2. event "Team Quote Started" (starts the Klaviyo flow), 3. marketing only if ticked.
      var profile = post('profiles', { data: { type: 'profile', attributes: profileAttrs } });
      var event = post('events', { data: { type: 'event', attributes: {
        properties: payload, value: payload.total, value_currency: payload.currency, unique_id: offer.id,
        metric: { data: { type: 'metric', attributes: { name: cfg.capture.metric || 'Team Quote Started' } } },
        profile: { data: { type: 'profile', attributes: { email: payload.email } } }
      } } });
      var sub = (offer.news && cfg.capture.list) ? post('subscriptions', { data: { type: 'subscription', attributes: {
        custom_source: 'Teams page',
        profile: { data: { type: 'profile', attributes: { email: payload.email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
      }, relationships: { list: { data: { type: 'list', id: cfg.capture.list } } } } }) : Promise.resolve(null);
      window.ascTeamsLeadCalls = (offer.news && cfg.capture.list) ? 3 : 2;
      return Promise.all([profile, event, sub]).then(function (r) { return { sent: !!(r[1] && r[1].ok) }; }, function () { return { sent: false }; });
    }

    /* ---------- overlay ---------- */
    var lastFocus = null;
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
    function stepMs() { return reduceMq.matches ? 0 : STEP_MS; }
    function addStep(html, waiting) {
      var li = document.createElement('li');
      if (waiting) li.className = 'is-wait';
      li.innerHTML = '<span>' + html + '</span>';
      el.ovSteps.appendChild(li);
      return li;
    }
    function setBar(p) { el.ovBar.style.width = Math.round(p * 100) + '%'; }
    function trapTab(e) {
      if (e.key === 'Tab') {
        var focusables = Array.prototype.filter.call(el.ov.querySelectorAll('button, [href], [tabindex="-1"]'), function (n) { return n.offsetParent !== null; });
        if (focusables.length <= 1) { e.preventDefault(); return; }
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      } else if (e.key === 'Escape' && !el.ovErr.hidden) {
        closeOverlay(true);
      }
    }
    function openOverlay() {
      lastFocus = document.activeElement;
      el.ovSteps.innerHTML = '';
      el.ovErr.hidden = true;
      if (el.ovPrice) { el.ovPrice.hidden = true; el.ovPrice.innerHTML = ''; }
      setBar(0);
      el.ov.hidden = false;
      document.documentElement.classList.add('asc-teams-lock');
      document.addEventListener('keydown', trapTab, true);
      el.ovTitle.textContent = 'Putting your team’s offer together';
      el.ovTitle.focus();
    }
    function closeOverlay(restore) {
      el.ov.hidden = true;
      document.documentElement.classList.remove('asc-teams-lock');
      document.removeEventListener('keydown', trapTab, true);
      if (restore && lastFocus && lastFocus.focus) lastFocus.focus();
    }
    el.ovBack.addEventListener('click', function () { closeOverlay(true); });

    /* ---------- submit ---------- */
    var busy = false;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      if (validate(false).length) return;
      busy = true;
      var offer = buildOffer();
      el.done.hidden = true;
      run(offer).then(function () { busy = false; }, function () { busy = false; });
    });

    function run(offer) {
      var started = Date.now();
      openOverlay();
      var work = fillCart(offer);
      work.catch(function () {});
      var lead = (offer.email ? sendLead(offer) : Promise.resolve(null)).catch(function () { return { sent: false }; });
      var types = offer.docks.map(function (d) { return d.type; });
      var steps = [];
      steps.push('<b>' + plural(offer.total, 'dock', 'docks') + '</b> for ' + plural(offer.docks.length, 'MacBook model', 'MacBook models'));
      steps.push('Each Mac matched to its dock: <b>' + types.join(', ') + '</b>');
      if (offer.trays.length) {
        var nt = offer.trays.reduce(function (s, t) { return s + t.qty; }, 0);
        var kinds = offer.trays.map(function (t) { return TRAY_SIZES[t.size] + ' ' + COLOURS[t.colour].toLowerCase(); });
        steps.push('<b>' + plural(nt, 'CableCare Tray', 'CableCare Trays') + '</b>: ' + (kinds.length <= 3 ? kinds.join(', ') : kinds.length + ' sizes and colors'));
      }
      if (offer.pct) steps.push('Team price: <b>' + offer.pct + '% off every dock</b>');
      var totalSteps = steps.length + 1;
      var chain = Promise.resolve();
      steps.forEach(function (s, i) {
        chain = chain.then(function () {
          addStep(s);
          setBar((i + 1) / (totalSteps + 0.5));
          return wait(stepMs());
        });
      });
      var fillLi;
      return chain.then(function () {
        fillLi = addStep('Filling your cart', true);
        // Never spin forever: after 30 s say so (the add may still land; the cart shows it).
        return Promise.race([work, wait(30000).then(function () { throw new Error('This is taking longer than usual. Open your cart in a minute to check'); })]);
      }).then(function (res) {
        var minShown = reduceMq.matches ? 700 : 0;
        var left = Math.max(0, minShown - (Date.now() - started));
        var discount = cartDiscountFor(res.cart, offer);
        fillLi.classList.remove('is-wait');
        fillLi.innerHTML = '<span>' + (res.replaced ? 'Your earlier team offer replaced. ' : '') + 'Your cart is ready</span>';
        // The result: Shopify's real team discount when it applied one, else the expected team price (section setting).
        var list = offer.dockSubtotal + offer.traySubtotal;
        var expected = teamSaving(offer.qtys);
        // After the submit only Shopify's real discount is shown; if no code applied, the page makes no price claim.
        offer.result = discount > 0 ? { save: discount, real: true } : { save: 0, real: false };
        var ntr = offer.trays.reduce(function (x, t) { return x + t.qty; }, 0);
        el.ovPrice.innerHTML = priceTable(list, offer.result.save, offer.result.real, { n: offer.total, nt: ntr, docks: offer.dockSubtotal, trays: offer.traySubtotal, pct: offer.pct });
        el.ovPrice.hidden = !offer.result.save;
        if (offer.pct && discount === 0 && window.console) {
          console.warn('[asc-teams] no team code applied (codes not set, or the code was not applicable): no team price shown after the submit.');
        }
        setBar(1);
        document.dispatchEvent(new CustomEvent('asc:teams:offer', { detail: { docks: offer.total, models: offer.docks.length, trays: offer.trays.length, value: offer.dockSubtotal + offer.traySubtotal, discount: discount, currency: cfg.currency } }));
        return Promise.all([wait(Math.max(left, reduceMq.matches ? 0 : (offer.result.save ? 1800 : 550))), lead]).then(function (r) {
          closeOverlay(false);
          showDone(offer, discount, r[1]);
          openCart(res.api);
        });
      }).catch(function (err) {
        if (fillLi) { fillLi.classList.remove('is-wait'); fillLi.classList.add('is-fail'); fillLi.innerHTML = '<span>Your cart could not be filled</span>'; }
        el.ovTitle.textContent = 'Something went wrong';
        var raw = err && err.message ? String(err.message).trim() : '';
        if (/abort|network|failed to fetch|load failed/i.test(raw)) raw = 'The shop took too long to answer. Please try again in a moment';
        var msg = raw ? raw.replace(/[.\s]+$/, '') + '. ' : '';
        el.ovErrText.textContent = msg + (/try again/i.test(msg) ? ' You can also order on the dock page.' : ' Please try again, or order on the dock page.');
        el.ovErr.hidden = false;
        el.ovBack.focus();
        throw err;
      });
    }

    function showDone(offer, discount, lead) {
      var parts = [plural(offer.total, 'dock', 'docks')];
      var nt = offer.trays.reduce(function (s, t) { return s + t.qty; }, 0);
      if (nt) parts.push(plural(nt, 'CableCare Tray', 'CableCare Trays'));
      el.doneTitle.textContent = 'Your team’s cart is ready: ' + parts.join(' and ') + '.';
      var txt = '';
      if (offer.result && offer.result.save) {
        txt += 'Your team total: ' + money(offer.dockSubtotal + offer.traySubtotal - offer.result.save) + ', with the team price applied in your cart. ';
      }
      if (lead && lead.sent) txt += 'We’ll email this team quote to ' + offer.email + ' so you can come back to it. ';
      else if (lead && lead.demo) txt += 'Preview: nothing was sent (lead capture is off). ';
      txt += 'Send the link below to a colleague and it rebuilds this offer on their device.';
      el.doneText.textContent = txt;
      el.copy.setAttribute('data-link', offer.link);
      el.copyStatus.textContent = '';
      el.done.hidden = false;
    }
    el.copy.addEventListener('click', function () {
      var link = el.copy.getAttribute('data-link') || location.href;
      var ok = function () { el.copyStatus.textContent = 'Link copied.'; };
      var fail = function () { el.copyStatus.innerHTML = 'Copy this link: <a class="asc-teams__a" href="' + link.replace(/"/g, '&quot;') + '">' + link.replace(/</g, '&lt;') + '</a>'; };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(ok, fail);
      else fail();
    });
    el.openCart.addEventListener('click', function (e) {
      if (window.ascCart && typeof window.ascCart.open === 'function') { e.preventDefault(); e.stopPropagation(); window.ascCart.open(); }
    });

    prefill();
    update();
    root.setAttribute('data-ready', '');
  }

  function boot() { document.querySelectorAll('[data-asc-teams]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
